import { decode } from "he";
import ReactHtmlParser from "react-html-parser";

export const decodeHtmlContent = (content: string) => {
  if (!content) return "";
  return decode(content);
};

export const decodeAndParseHtmlContent = (content: string) => {
  return ReactHtmlParser(decodeHtmlContent(content));
};
